// ----------------------------------------------------------------------
// <copyright file="Izenda.ArrayUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  'use strict';
  const { isString, isNil, map } = require('lodash/fp');
  /**
   * Compare string.
   * @param  {String} firstOperand
   * @param  {String} secondOperand
   */
  function compareString(firstOperand, secondOperand) {
    // We do not care case-insensitive when compare strings.
    return firstOperand.localeCompare(secondOperand, undefined /* Ignore language */, { sensitivity: 'base' });
  }

  /**
   * Compare function.
   * @param  {Object} sortInfo
   */
  function dynamicSort(sortInfo) {
    return function(firstOperand, secondOperand) {
      var result = 0;

      if (isString(firstOperand)) {
        result = compareString(firstOperand[sortInfo.key], secondOperand[sortInfo.key]);
      } else {
        result =
          firstOperand[sortInfo.key] > secondOperand[sortInfo.key]
            ? 1
            : firstOperand[sortInfo.key] < secondOperand[sortInfo.key]
              ? -1
              : 0;
      }

      return sortInfo.descending ? -1 * result : result;
    };
  }

  /**
   * Compare function for multi props.
   */
  function dynamicSortMultiple() {
    var props = arguments;
    return function(firstOperand, secondOperand) {
      var i = 0,
        result = 0,
        numberOfProperties = props.length;
      while (result === 0 && i < numberOfProperties) {
        result = dynamicSort(props[i])(firstOperand, secondOperand);
        i++;
      }
      return result;
    };
  }

  module.exports = {
    /**
     * Sort items of array with support asc/desc.
     * Item is an object.
     */
    sortArray: function(items, sortInfos) {
      // Handle invalid sort order detail.
      if (isNil(sortInfos)) {
        return items;
      }

      var sortedItems = items.sort(dynamicSortMultiple.apply(null, sortInfos));
      return sortedItems;
    },

    /**
     * Update array
     * This is a helper for update observable array, also can use for array.
     */
    updateArray: function(target, source, transfomer) {
      //Clean current list and append new list
      target.splice.apply(target, [0, target.length].concat(map(transfomer, source)));
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.ArrayUtils.js